import { ChevronDown, X } from 'lucide-react';
import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface FilterPillProps {
  label: string;
  active?: boolean;
  onClear?: () => void;
  onClick?: () => void;
  trailingIcon?: ReactNode;
  className?: string;
}

export function FilterPill({
  label,
  active = false,
  onClear,
  onClick,
  trailingIcon,
  className,
}: FilterPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'inline-flex items-center gap-1.5 h-8 px-3 rounded-pill border text-caption font-medium transition-colors',
        active
          ? 'border-brand-blue bg-status-info-bg text-brand-blue'
          : 'border-line bg-white text-ink hover:bg-canvas',
        className,
      )}
    >
      {active && <span className="h-1.5 w-1.5 rounded-full bg-brand-blue" />}
      <span>{label}</span>
      {active && onClear ? (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
          className="ml-0.5 rounded-full hover:bg-brand-blue/15 p-0.5"
          aria-label="Clear filter"
        >
          <X className="h-3 w-3" />
        </button>
      ) : (
        trailingIcon ?? <ChevronDown className="h-3.5 w-3.5 opacity-60" />
      )}
    </button>
  );
}
